var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#7029a3",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.6666 18.333c0-0.7364 0.59696-1.3334 1.3333-1.3334 0.7364 0 1.3334 0.597 1.3334 1.3334s-0.597 1.3333-1.3334 1.3333c-0.73633 0-1.3333-0.5969-1.3333-1.3333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11 22.333c-0.73633 0-1.3333 0.5969-1.3333 1.3333s0.59696 1.3333 1.3333 1.3333c0.7364 0 1.3334-0.5969 1.3334-1.3333s-0.597-1.3333-1.3334-1.3333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15 18.333c0-0.7364 0.5969-1.3334 1.3333-1.3334s1.3334 0.597 1.3334 1.3334-0.597 1.3333-1.3334 1.3333-1.3333-0.5969-1.3333-1.3333z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.333 22.333c-0.7364 0-1.3333 0.5969-1.3333 1.3333s0.5969 1.3333 1.3333 1.3333 1.3334-0.5969 1.3334-1.3333-0.597-1.3333-1.3334-1.3333z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m20.333 18.333c0-0.7364 0.5969-1.3334 1.3333-1.3334s1.3334 0.597 1.3334 1.3334-0.597 1.3333-1.3334 1.3333-1.3333-0.5969-1.3333-1.3333z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m21.667 22.333c-0.7364 0-1.3333 0.5969-1.3333 1.3333s0.5969 1.3333 1.3333 1.3333 1.3334-0.5969 1.3334-1.3333-0.597-1.3333-1.3334-1.3333z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m8.3333 2.3333c0-0.73638 0.59696-1.3333 1.3333-1.3333 0.73635 0 1.3334 0.59696 1.3334 1.3333v1.3333h10.667v-1.3333c0-0.73638 0.5969-1.3333 1.3333-1.3333s1.3333 0.59696 1.3333 1.3333v1.3333h1.3334c2.209 0 4 1.7909 4 4v18.667c0 2.2093-1.791 4-4 4h-18.667c-2.2092 0-4-1.7907-4-4v-18.667c0-2.2091 1.7908-4 4-4h1.3333zm13.333 4v1.3333c0 0.73637 0.5969 1.3333 1.3333 1.3333s1.3333-0.59696 1.3333-1.3333v-1.3333h1.3334c0.7364 0 1.3333 0.59696 1.3333 1.3333v4h-21.333v-4c0-0.73637 0.59696-1.3333 1.3333-1.3333h1.3333v1.3333c0 0.73637 0.59696 1.3333 1.3333 1.3333 0.73635 0 1.3334-0.59696 1.3334-1.3333v-1.3333zm-16 8v12c0 0.7362 0.59696 1.3333 1.3333 1.3333h18.667c0.7364 0 1.3333-0.5971 1.3333-1.3333v-12z",
    clipRule: "evenodd",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.96de3f50067e878ab83ed112c5675626.svg";
export { ForwardRef as ReactComponent };